import { Box } from "@mui/material";
import { apiService } from "constants/axiosInstance";
import { CustomEventDispose, CustomEventListener } from "constants/events";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import NumberReport from "./NumberReport";
import { ENTITY_TYPE } from "./ReportCreation/DropdownEntity";
import { VALUE_CAL } from "./ReportCreation/DropdownValue";
import { REPORT_TYPE } from "./ReportCreation/ReportCreation";
import TableReport from "./TableReport";
import TableSummary from "./TableSummary";

export const convertData = ({
  dataReport = {},
  data = {},
  categoryId = {},
  setData = (val) => {},
}) => {
  let form = {};
  form.name = data.name;
  form.description = data.description;
  form.category_id = categoryId;

  form.report_type = dataReport?.report_type;

  form.entity_type = dataReport?.entity_report;
  if (form.entity_type === ENTITY_TYPE.MEMBER) {
    form.entity_options = dataReport?.member?.list ?? [];
    form.entity_type_select = dataReport?.member?.type_get;
  }
  if (form.entity_type === ENTITY_TYPE.GROUP_TASK) {
    form.entity_options = dataReport?.group_task?.list ?? [];
    form.entity_type_select = dataReport?.group_task?.type_get;
  }
  if (form.entity_type === ENTITY_TYPE.PRIORITY) {
    form.entity_options = dataReport?.priority?.list ?? [];
    form.entity_type_select = dataReport?.priority?.type_get;
  }
  if (form.entity_type === ENTITY_TYPE.STATUS) {
    form.entity_options = dataReport?.status?.list ?? [];
    form.entity_type_select = dataReport?.status?.type_get;
  }
  if (form.entity_type === ENTITY_TYPE.DROPDOWN_FIELD) {
    form.project_field_id = dataReport?.project_field?.field_id;
    form.entity_options = dataReport?.project_field?.list ?? [];
    form.entity_type_select = dataReport?.project_field?.type_get;
  }

  form.value_calculate = dataReport?.value_calculate?.from;
  if (form.value_calculate === VALUE_CAL.PROJECT_FIELD) {
    form.value_calculate_field = dataReport?.value_calculate?.project_field;
  }

  if (form.report_type === REPORT_TYPE.NUMBER) {
    form.value_calculate_method = dataReport?.value_calculate.method;
  } else {
    form.skip_result = dataReport?.skip_result;
  }

  if (form.report_type === REPORT_TYPE.TABLE) {
    form.entity_summary = dataReport?.entity_summary;
    form.entity_summary_field = dataReport?.entity_summary_field;
  }

  form.conditions = dataReport?.conditions;

  form.color = dataReport?.color;

  console.log(data, "data report item");

  setData({
    ...data,
    detail: dataReport,
    form,
  });
};

const ReportItem = ({
  categoryId,
  defaultData,
  handleEdit,
  handleDelete,
  handlePreview,
}) => {
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const [data, setData] = useState(defaultData);

  const getData = async (nameDescription = {}) => {
    try {
      const response = await apiService({
        url: "/project/report/get-report-detail",
        method: "GET",
        params: {
          report_id: defaultData?.id,
        },
      });

      if (response?.data?.state) {
        const payload = {
          ...data,
          ...(nameDescription.name && { name: nameDescription.name }),
          ...(nameDescription.description && {
            description: nameDescription.description,
          }),
        };
        convertData({
          dataReport: response?.data?.report,
          categoryId,
          data: payload,
          setData,
        });
        setLoading(false);
      }
    } catch (e) {}
  };

  useEffect(() => {
    getData();
    CustomEventListener(
      "report-" + defaultData.id,
      ({ detail: { name, description } }) => {
        console.log(name, description, "update report");
        getData({ name, description });
      }
    );
    return () => {
      CustomEventDispose(
        "report-" + defaultData.id,
        ({ detail: { name, description } }) => {
          getData({ name, description });
        }
      );
    };
  }, []);

  if (loading) return <></>;

  if (data?.is_hidden) return <></>;

  if (data?.form?.report_type === REPORT_TYPE.NUMBER) {
    return (
      <NumberReport
        title={data?.form?.name}
        count={data?.detail?.summary_value_total ?? 0}
        backgroundColor={data?.form?.color ?? "white"}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handlePreview={() => {
          handlePreview(data.form);
        }}
        report={data}
      />
    );
  }

  if (data?.form?.report_type === REPORT_TYPE.TABLE) {
    return (
      <TableReport
        report={data}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handlePreview={() => {
          handlePreview(data.form);
        }}
      />
    );
  }

  if (data?.form?.report_type === REPORT_TYPE.SUMMARY) {
    return (
      <TableSummary
        report={data}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handlePreview={() => {
          handlePreview(data.form);
        }}
      />
    );
  }

  return (
    <Box
      sx={{ border: "1px solid black", marginRight: "10px" }}
      onClick={() => {
        handleEdit(data);
      }}
    >
      {data.name}
      {data.description}
    </Box>
  );
};

export default ReportItem;
